import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';

import {UseControllerOptions, useController} from 'react-hook-form';
import {SelectOption} from 'packages/common-types/base-types';
import {v4 as uuidv4} from 'uuid';
import {FormHelperText} from '@material-ui/core';

type FormSelectProps = UseControllerOptions & {
  className: string;
  selectProps: {
    label: string;
    id: string;
    placeholder?: string;
    options: SelectOption[];
    errorMessage?: string;
  };
};

function FormSelect(props: FormSelectProps): JSX.Element {
  const {
    className,
    selectProps: {id, label, placeholder, options, errorMessage},
    ...controllerOptions
  } = props;

  const {
    field: {name, onBlur, onChange, ref, value},
  } = useController(controllerOptions);

  return (
    <>
      <FormControl
        margin="dense"
        className={className}
        error={errorMessage && true}
        variant="outlined"
        fullWidth
      >
        <InputLabel htmlFor={name}>{label}</InputLabel>
        <Select
          ref={ref}
          onBlur={onBlur}
          onChange={onChange}
          value={value}
          id={id}
          name={name}
          placeholder={placeholder}
          label={label}
        >
          <MenuItem value="">
            <em>{placeholder || 'Selecciona una opción'}</em>
          </MenuItem>
          {options.map((item) => (
            <MenuItem key={uuidv4()} value={item.value}>
              {item.label}
            </MenuItem>
          ))}
        </Select>
        {errorMessage && <FormHelperText>{errorMessage}</FormHelperText>}
      </FormControl>
    </>
  );
}

export default FormSelect;
